import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { PermissionProfile } from '../enums/generated/PermissionProfile';

export const getSubNavSite: () => NavRoute = () => { 
	return { 
		name: getName()
        , href: 'sites'
		, security: security => security.coreFeatures
		, children: getSiteAreas()
        , isSubNav: true
	};
};

function getName() : string {
	let name: string;
    let url = globalThis.location.href;
	if (
		url.includes('sites/edit/details/')
		|| url.includes('sites/edit/daily-count/')
		|| url.includes('sites/edit/inventory/')
		|| url.includes('sites/edit/burn-rate/')
		|| url.includes('sites/edit/business-days/')
		|| url.includes('sites/edit/site-users/')
		|| url.includes('sites/edit/audit-history/')
	) { name = "Edit Site"; } 
	else { name = "Sites"; }

	return name;
}

function getSiteAreas() : NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('sites/edit/details/')) { 
		if (url.includes('?orgId=')) { id = url.substring(url.lastIndexOf('/') + 1, url.indexOf('?')); }
		else { id = url.substring(url.lastIndexOf('/') + 1);  }
	}
	if (url.includes('sites/edit/daily-count/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('sites/edit/inventory/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('sites/edit/burn-rate/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('sites/edit/business-days/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('sites/edit/site-users/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('sites/edit/audit-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	// Sites list
	if (id === "") { 
		return [
			{
				name: 'By Event'
				, exact: true
				, path: 'sites/by-event'
                , activeNavLink: 'sites/by-event'
		        , secondaryNav: ['Sites', 'By Event']
			}
		]; 
	}

	// Creating a new Site
	if (+id === 0) {
		return [
			{
				name: 'Back'
				, exact: true
				, path: `sites/by-event`
                , activeNavLink: 'sites/by-event'
		        , secondaryNav: ['Sites', 'By Event']
			}
            , {
				name: 'Details'
				, exact: true
				, path: `sites/edit/details/${id}`
                , activeNavLink: 'sites/edit/details'
		        , secondaryNav: ['Sites', 'Edit Site', 'Details']
			}
		];
	}

	// Site details
	return [
		{
			name: 'Back'
			, exact: true
			, path: 'sites/by-event'
            , activeNavLink: 'sites/by-event'
            , secondaryNav: ['Sites', 'By Event']
		}
        , {
			name: 'Inventory Count'
			, exact: true
			, path: `sites/edit/daily-count/${id}`
            , activeNavLink: 'sites/edit/daily-count'
            , secondaryNav: ['Sites', 'Edit Site', 'Daily Count']
		}
        , {
			name: 'Inventory'
			, exact: true
			, path: `sites/edit/inventory/${id}`
            , activeNavLink: 'sites/edit/inventory'
            , secondaryNav: ['Sites', 'Edit Site', 'Inventory']
		}
        , {
			name: 'Burn Rate'
			, exact: true
			, path: `sites/edit/burn-rate/${id}`
            , activeNavLink: 'sites/edit/burn-rate'
            , secondaryNav: ['Sites', 'Edit Site', 'Burn Rate']
		}
        , {
			name: 'Details'
			, exact: true
			, path: `sites/edit/details/${id}`
            , activeNavLink: 'sites/edit/details'
            , secondaryNav: ['Sites', 'Edit Site', 'Details']
		}
        , {
			name: 'Business Days'
			, exact: true
			, path: `sites/edit/business-days/${id}`
            , activeNavLink: 'sites/edit/business-days'
            , secondaryNav: ['Sites', 'Edit Site', 'Business Days']
		}
        , {
			name: 'Associated Users'
			, exact: true
			, path: `sites/edit/site-users/${id}`
			, security: security => security.permissionProfile !== PermissionProfile.SiteUser
            , activeNavLink: 'sites/edit/site-users'
            , secondaryNav: ['Sites', 'Edit Site', 'Associated Users']
		}
        , {
			name: 'Audit History'
			, exact: true
			, path: `sites/edit/audit-history/${id}`
			, security: security => security.permissionProfile !== PermissionProfile.SiteUser
            , activeNavLink: 'sites/edit/audit-history'
            , secondaryNav: ['Sites', 'Edit Site', 'Audit History']
		}
	];
}
